import React from 'react';
import { TaskStatus as TaskStatusType } from '../types/todo';
import { CheckCircle2, Circle, Clock } from 'lucide-react';

interface TaskStatusProps {
  status: TaskStatusType;
  isPreview: boolean;
}

export function TaskStatus({ status, isPreview }: TaskStatusProps) {
  const getStatusConfig = (s: TaskStatusType) => {
    switch (s) {
      case 'completed':
        return {
          label: 'Terminé',
          icon: <CheckCircle2 className="w-5 h-5 sm:w-4 sm:h-4" />,
          classes: isPreview
            ? 'bg-gray-100 text-gray-600'
            : 'bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 hover:bg-emerald-100 dark:hover:bg-emerald-900/30 active:scale-90'
        };
      case 'in-progress':
        return {
          label: 'En cours',
          icon: <Clock className="w-5 h-5 sm:w-4 sm:h-4" />,
          classes: isPreview
            ? 'bg-gray-100 text-gray-600'
            : 'bg-amber-50 dark:bg-amber-900/20 text-amber-600 dark:text-amber-400 hover:bg-amber-100 dark:hover:bg-amber-900/30 active:scale-90'
        };
      default:
        return {
          label: 'À faire',
          icon: <Circle className="w-5 h-5 sm:w-4 sm:h-4" />,
          classes: isPreview
            ? 'bg-gray-100 text-gray-600'
            : 'bg-gray-100 dark:bg-gray-700 text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-600 active:scale-90'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <div className={`flex items-center justify-center min-w-[2.75rem] min-h-[2.75rem] sm:min-w-0 sm:min-h-0 p-2.5 sm:p-1 sm:gap-1.5 sm:px-2.5 sm:py-1 rounded-xl sm:rounded-lg text-xs font-medium transition-all duration-150 ${config.classes}`}>
      {config.icon}
      <span className="hidden sm:inline">{config.label}</span>
    </div>
  );
}
